import { getClientIdentityHeaders } from "./clientIdentity";

type ResearchType = "digital-asset-trader" | "tradfi" | "digital-assets" | "intelligence-evidence" | "ideas";

export interface PdfExportInput {
  reportId?: string | null;
  title?: string;
  symbol: string;
  researchType: ResearchType;
  provider?: string | null;
  model?: string | null;
  markdown?: string | null;
}

function filenameFromDisposition(value: string | null) {
  const match = value?.match(/filename="?([^";]+)"?/i);
  return match?.[1] ?? null;
}

function fallbackPdfName(input: PdfExportInput) {
  const symbol = input.symbol.toLowerCase().replace(/[^a-z0-9.-]+/g, "-").replace(/^-+|-+$/g, "") || "asset";
  return `tsm-${symbol}-${input.researchType}-report.pdf`;
}

export function downloadMarkdown(markdown: string, filename: string) {
  const blob = new Blob([markdown], { type: "text/markdown" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export async function downloadReportPdf(input: PdfExportInput) {
  const res = await fetch("/api/reports/pdf", {
    method: "POST",
    headers: { "Content-Type": "application/json", ...getClientIdentityHeaders() },
    credentials: "include",
    body: JSON.stringify({
      reportId: input.reportId || undefined,
      title: input.title,
      symbol: input.symbol,
      researchType: input.researchType,
      provider: input.provider,
      model: input.model,
      markdown: input.markdown || undefined,
    }),
  });

  if (!res.ok) {
    const data = await res.json().catch(() => null) as { error?: string; detail?: string } | null;
    throw new Error(data?.detail ?? data?.error ?? `PDF export failed (${res.status})`);
  }

  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filenameFromDisposition(res.headers.get("Content-Disposition")) ?? fallbackPdfName(input);
  a.click();
  URL.revokeObjectURL(url);
}
